import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    solicitud: {},
    valid: false,
    ok: null,
    cancel: null,
    lang: 'es'
  },
  mutations: {
    setSolicitud (state, value) {
      state.solicitud = value;
    },
    setDate (state, value) {
      if (!state[value.prop]) {
        state[value.prop] = {};
      }
      state[value.prop][value.key] = value.value;
    },
    setValid (state, value) {
      state.valid = value;
    },
    setOk (state, value) {
      state.ok = value;
    },
    setCancel (state, value) {
      state.cancel = value;
    },
    setLang (state, value) {
      state.lang = value;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js